export interface ITermSelect {
  value: string
  label: string
  current: true
}